<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Permite seleccionar una fecha</p>
    <f7-row>
      <f7-col
        class="display-flex justify-content-center margin-top margin-bottom"
        width="100"
      >
        <UCDatePicker
          id="1"
          title="Fecha consulta"
        />
      </f7-col>
    </f7-row>
    <f7-row>
      <f7-col
        class="display-flex justify-content-center margin-top margin-bottom"
        width="100"
      >
        <UCDatePicker
          id="2"
          title="Rango de fechas"
          :init-null="true"
          :default-value="null"
          :range-picker="true"
          date-format="dd/mm"
        />
      </f7-col>
    </f7-row>
  </f7-block>
</template>

<script>
import UCDatePicker from '@/components/common/UCDatePicker.vue';

export default {
  name: 'TestUCDatePicker',
  components: {
    UCDatePicker,
  },
};
</script>
